import React from 'react';
import './HeroSection.css';

function HeroSection() {
    return (
        <section id="hero" className="hero">
            <div className="hero__overlay"></div>
            <div className="hero__content">
                <h2 className="hero__title">Vive la adrenalina del paracaidismo</h2>
                <p className="hero__subtitle">
                    Aprende y salta con los mejores instructores certificados.
                </p>
                <a
                    className="hero__button"
                    href="https://wa.me/59898604727"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Reserva tu Salto
                </a>
            </div>
        </section>
    );
}

export default HeroSection;
